/*
 * ルーティングの際の認証処理
 * - token
 *   原則、APIコール時のtoken付与により認証を行っているため、
 *   tokenの存在のみを検証する
 *
 * - campaignHash
 *   ログイン時に保存されるであろうstore内のcampaignCodeと照合する
 */

import TokenManager from '../utils/TokenManager';
import StorageManager from '../utils/StorageManager';

export const authorizeMeta = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresToken)) {
    // マッチしたルートにおいて、メタフィールドに`requiresToken`が付与されている場合は
    // ログインした際に付与される認証トークンがあるかどうかチェックする
    if (!TokenManager.isLogin()) {
      const campaignCode = to.params.campaignCode
        ? to.params.campaignCode
        : StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
      next({ path: `/cp/${campaignCode}/login` });
    }
  }

  next();
};
